import { createFileRoute } from "@tanstack/react-router";

import { PraxaAccountSettings } from "../components/settings/PraxaAccountSettingsPage";

function SettingsAccountRoute() {
  return <PraxaAccountSettings />;
}

export const Route = createFileRoute("/settings/account")({
  component: SettingsAccountRoute,
});
